module.exports = __webpack_public_path__ + "img/content4-2.f9dfc260.webp";